export function Labels() {
  return (
    <div
      style={{
        display: 'flex',
        borderBottom: '1px #000 solid',
        pageBreakInside: 'avoid',
      }}
    >
      <div
        style={{
          flex: '1',
          padding: '8px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <span style={{ fontSize: '10px', textAlign: 'center' }}>
          * Itens restritivos e/ou impeditivos para início das atividades de
          Operações. O preenchimento da RAA será imediato (Desvios ocorridos a
          critério).
        </span>
        <span style={{ fontSize: '10px', textAlign: 'center' }}>
          Tolerância: Minímo p/ CCT de plantio - 90% (Se for abaixo o Gestor da
          área deverá analisar a liberação / justificar ).
        </span>
      </div>
      <div
        style={{
          display: 'flex',
          flex: '1',
          justifyContent: 'space-evenly',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            borderRight: '1px #000 solid',
            borderLeft: '1px #000 solid',
            paddingRight: '16px',
            paddingLeft: '16px',
            gap: '16px',
          }}
        >
          <span style={{ fontWeight: 'bold', fontSize: '10px' }}>Ótimo:</span>
          <span style={{ fontSize: '10px', whiteSpace: 'nowrap' }}>
            Acima de 95%
          </span>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            borderRight: '1px #000 solid',
            paddingRight: '16px',
            paddingLeft: '16px',
            gap: '16px',
          }}
        >
          <span style={{ fontWeight: 'bold', fontSize: '10px' }}>Bom:</span>
          <span style={{ fontSize: '10px', whiteSpace: 'nowrap' }}>
            90% à 95%
          </span>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            paddingRight: '16px',
            paddingLeft: '16px',
            gap: '16px',
          }}
        >
          <span style={{ fontWeight: 'bold', fontSize: '10px' }}>Ruim:</span>
          <span style={{ fontSize: '10px', whiteSpace: 'nowrap' }}>
            Abaixo de 90%
          </span>
        </div>
      </div>
    </div>
  );
}
